import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _55d80f6a = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _5dca6030 = () => interopDefault(import('../../../pages/expenses/index.vue' /* webpackChunkName: "pages/expenses/index" */))
const _2324cf28 = () => interopDefault(import('../../../pages/gdpr/index.vue' /* webpackChunkName: "pages/gdpr/index" */))
const _3ece0976 = () => interopDefault(import('../../../pages/income/index.vue' /* webpackChunkName: "pages/income/index" */))
const _3737adf3 = () => interopDefault(import('../../../pages/invoices/index.vue' /* webpackChunkName: "pages/invoices/index" */))
const _43a831cf = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _7e6f1094 = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _6841a1ca = () => interopDefault(import('../../../pages/patients/index.vue' /* webpackChunkName: "pages/patients/index" */))
const _1bfd1281 = () => interopDefault(import('../../../pages/practices/index.vue' /* webpackChunkName: "pages/practices/index" */))
const _0f9f7f06 = () => interopDefault(import('../../../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _3b189468 = () => interopDefault(import('../../../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _04abb52a = () => interopDefault(import('../../../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _7db7f522 = () => interopDefault(import('../../../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _466d1e82 = () => interopDefault(import('../../../pages/sms/index.vue' /* webpackChunkName: "pages/sms/index" */))
const _4d7bc26a = () => interopDefault(import('../../../pages/subscription/index.vue' /* webpackChunkName: "pages/subscription/index" */))
const _23fe4ced = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _d93d1662 = () => interopDefault(import('../../../pages/account/settings.vue' /* webpackChunkName: "pages/account/settings" */))
const _7936d334 = () => interopDefault(import('../../../pages/gdpr/consent.vue' /* webpackChunkName: "pages/gdpr/consent" */))
const _dac7f98e = () => interopDefault(import('../../../pages/invoices/open.vue' /* webpackChunkName: "pages/invoices/open" */))
const _0d8fc5fe = () => interopDefault(import('../../../pages/invoices/past.vue' /* webpackChunkName: "pages/invoices/past" */))
const _378025b6 = () => interopDefault(import('../../../pages/practice/create.vue' /* webpackChunkName: "pages/practice/create" */))
const _2d074a7e = () => interopDefault(import('../../../pages/practice/employees/index.vue' /* webpackChunkName: "pages/practice/employees/index" */))
const _5b51d4dd = () => interopDefault(import('../../../pages/practice/settings.vue' /* webpackChunkName: "pages/practice/settings" */))
const _3bca132e = () => interopDefault(import('../../../pages/practice/employees/_id/index.vue' /* webpackChunkName: "pages/practice/employees/_id/index" */))
const _4b1dbcd8 = () => interopDefault(import('../../../pages/practice/employees/_id/availability.vue' /* webpackChunkName: "pages/practice/employees/_id/availability" */))
const _116ac7d4 = () => interopDefault(import('../../../pages/practice/employees/_id/holidays.vue' /* webpackChunkName: "pages/practice/employees/_id/holidays" */))
const _58482238 = () => interopDefault(import('../../../pages/couples/_coupleId.vue' /* webpackChunkName: "pages/couples/_coupleId" */))
const _ffa69a08 = () => interopDefault(import('../../../pages/groups/_groupId.vue' /* webpackChunkName: "pages/groups/_groupId" */))
const _0add6364 = () => interopDefault(import('../../../pages/invitation/_id.vue' /* webpackChunkName: "pages/invitation/_id" */))
const _7b64f4f0 = () => interopDefault(import('../../../pages/patients/_patientId.vue' /* webpackChunkName: "pages/patients/_patientId" */))
const _35210b2e = () => interopDefault(import('../../../pages/sessions/_eventId.vue' /* webpackChunkName: "pages/sessions/_eventId" */))
const _7a008eb8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/calendar",
    component: _55d80f6a,
    name: "calendar"
  }, {
    path: "/expenses",
    component: _5dca6030,
    name: "expenses"
  }, {
    path: "/gdpr",
    component: _2324cf28,
    name: "gdpr"
  }, {
    path: "/income",
    component: _3ece0976,
    name: "income"
  }, {
    path: "/invoices",
    component: _3737adf3,
    name: "invoices"
  }, {
    path: "/login",
    component: _43a831cf,
    name: "login"
  }, {
    path: "/logout",
    component: _7e6f1094,
    name: "logout"
  }, {
    path: "/patients",
    component: _6841a1ca,
    name: "patients"
  }, {
    path: "/practices",
    component: _1bfd1281,
    name: "practices"
  }, {
    path: "/registration",
    component: _0f9f7f06,
    name: "registration"
  }, {
    path: "/reports",
    component: _3b189468,
    name: "reports"
  }, {
    path: "/services",
    component: _04abb52a,
    name: "services"
  }, {
    path: "/signup",
    component: _7db7f522,
    name: "signup"
  }, {
    path: "/sms",
    component: _466d1e82,
    name: "sms"
  }, {
    path: "/subscription",
    component: _4d7bc26a,
    name: "subscription"
  }, {
    path: "/terms",
    component: _23fe4ced,
    name: "terms"
  }, {
    path: "/account/settings",
    component: _d93d1662,
    name: "account-settings"
  }, {
    path: "/gdpr/consent",
    component: _7936d334,
    name: "gdpr-consent"
  }, {
    path: "/invoices/open",
    component: _dac7f98e,
    name: "invoices-open"
  }, {
    path: "/invoices/past",
    component: _0d8fc5fe,
    name: "invoices-past"
  }, {
    path: "/practice/create",
    component: _378025b6,
    name: "practice-create"
  }, {
    path: "/practice/employees",
    component: _2d074a7e,
    name: "practice-employees"
  }, {
    path: "/practice/settings",
    component: _5b51d4dd,
    name: "practice-settings"
  }, {
    path: "/practice/employees/:id",
    component: _3bca132e,
    name: "practice-employees-id"
  }, {
    path: "/practice/employees/:id/availability",
    component: _4b1dbcd8,
    name: "practice-employees-id-availability"
  }, {
    path: "/practice/employees/:id/holidays",
    component: _116ac7d4,
    name: "practice-employees-id-holidays"
  }, {
    path: "/couples/:coupleId?",
    component: _58482238,
    name: "couples-coupleId"
  }, {
    path: "/groups/:groupId?",
    component: _ffa69a08,
    name: "groups-groupId"
  }, {
    path: "/invitation/:id?",
    component: _0add6364,
    name: "invitation-id"
  }, {
    path: "/patients/:patientId",
    component: _7b64f4f0,
    name: "patients-patientId"
  }, {
    path: "/sessions/:eventId?",
    component: _35210b2e,
    name: "sessions-eventId"
  }, {
    path: "/",
    component: _7a008eb8,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
